export default "__VITE_ASSET__DYo1JbzG__"